<template>
    <v-container fluid class="incidente-root">
        <h2>Reporte dinámico de funcionarios</h2>

        <!-- DATOS PaRA FILTRAR -->
        <v-card class="pa-3 mb-3 filtros-card" outlined>
            <v-row dense>
                <v-col cols="12" md="3">
                    <v-select v-model="campoFila" :items="camposDisponibles" item-text="text" item-value="value" label="Agrupar filas por" outlined dense />
                </v-col>
                <v-col cols="12" md="3">
                    <v-select v-model="campoColumna" :items="camposDisponibles" item-text="text" item-value="value" label="Agrupar columnas por" outlined dense />
                </v-col>
                <!-- <v-col cols="12" md="3">
                    <v-text-field v-model="search" label="Buscar funcionario" append-icon="mdi-magnify" outlined dense clearable />
                </v-col>
                <v-col cols="12" md="3">
                    <v-select v-model="soloActivos" :items="opcionesActivos" item-text="text" item-value="value" label="Estado" outlined dense clearable />
                </v-col> -->
            </v-row>
        </v-card>

        <!-- FILTROS -->
        <v-card class="pa-3 mb-3 filtros-card" outlined>
            <v-row dense align="center">
                <!-- <v-col cols="12" md="4">
                    <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar por nombres, apellidos, correo o documento" outlined dense clearable />
                </v-col> -->
                <v-col cols="12" md="2">
                    <v-select v-model="filtros.oid_estado" :items="Lestado" item-text="n_estado" item-value="oid" label="Estado" outlined dense multiple clearable />
                </v-col>
                <v-col cols="12" md="2">
                    <v-autocomplete v-model="filtros.oid_grado" :items="Lgrado" item-text="nombre" item-value="oid" label="Grado" outlined dense multiple clearable />
                </v-col>
                <v-col cols="12" md="2">
                    <v-autocomplete v-model="filtros.oid_unidad" :items="Lunidad" item-text="nombre" item-value="oid" label="Unidad" outlined dense multiple clearable />
                </v-col>
                <v-col cols="12" md="2">
                    <v-autocomplete v-model="filtros.oid_destino" :items="Ldestino" item-text="nombre" item-value="oid" label="Destino" outlined dense multiple clearable />
                </v-col>
                <v-col cols="12" md="2">
                    <v-autocomplete v-model="filtros.oid_categoria" :items="Lcas" item-text="nombre" item-value="oid" label="Categoria CAS" outlined dense multiple clearable />
                </v-col>

                <v-col cols="12" md="2" class="text-right">
                    <v-btn text color="#5e672c" @click="verFiltros = !verFiltros">
                        <v-icon left small>mdi-filter-variant</v-icon>
                        Más filtros
                    </v-btn>
                </v-col>
            </v-row>
            <v-expand-transition>
                <div v-if="verFiltros" class="mt-3">
                    <v-divider class="mb-3"></v-divider>
                    <v-row dense>
                        <v-col cols="12" md="3">
                            <v-autocomplete v-model="filtros.oid_depto" :items="LDepto" item-text="nombre" item-value="oid" label="Departamento" outlined dense multiple clearable />
                        </v-col>
                        <v-col cols="12" md="3">
                            <v-autocomplete v-model="filtros.oid_ciudad" :items="LCiudad" item-text="nombre" item-value="oid" label="Ciudad" outlined dense multiple clearable />
                        </v-col>
                        <v-col cols="12" md="2">
                            <v-select v-model="filtros.oid_genero" :items="Catalogo.Genero" item-text="nombre" item-value="oid" label="Género" outlined dense multiple clearable />
                        </v-col>
                        <v-col cols="12" md="2">
                            <v-select v-model="filtros.oid_estado_civil" :items="Catalogo.EstadoCivil" item-text="nombre" item-value="oid" label="Estado civil" outlined dense multiple clearable />
                        </v-col>
                        <v-col cols="12" md="3">
                            <v-autocomplete v-model="filtros.oid_cargo" :items="Lcargo" item-text="nombre" item-value="oid" label="Cargo" outlined dense multiple clearable />
                        </v-col>
                        <v-col cols="12" md="3">
                            <v-autocomplete v-model="filtros.oid_frontera" :items="Lfrontera" item-text="nombre" item-value="oid" label="Frontera" outlined dense multiple clearable />
                        </v-col>
                        <v-col cols="12" md="3">
                            <v-autocomplete v-model="filtros.oid_funciones" :items="Lfunciones" item-text="nombre" item-value="oid" label="Función Policial" outlined dense multiple clearable />
                        </v-col>
                        <v-col cols="12" md="3">
                            <v-autocomplete v-model="filtros.grado_policial" :items="Lgpolicial" item-text="nombre" item-value="oid" label="Grado Policial" outlined dense multiple clearable />
                        </v-col>
                    </v-row>
                </div>
            </v-expand-transition>
        </v-card>

        <!-- BOTONEs -->
        <v-row class="mb-3" align="center">
            <v-col cols="6">
                <v-btn small color="#5e672c" dark @click="listar">
                    <v-icon left small>mdi-refresh</v-icon>
                    Actualizar
                </v-btn>
            </v-col>

            <v-col cols="6" class="text-right">
                <v-btn small color="#e4b510" dark @click="exportarExcel">
                    <v-icon left small>mdi-microsoft-excel</v-icon>
                    Exportar XLSX
                </v-btn>
            </v-col>
        </v-row>

        <!-- TABLA -->
        <v-card class="tabla-card">
            <div class="tabla-wrap">
                <table class="rep-table">
                    <thead>
                        <tr>
                            <th class="sticky-col">{{ tituloFila }}</th>
                            <th v-for="col in columnas" :key="'head-' + col.key">
                                {{ col.nombre }}
                            </th>
                            <th>TOTAL</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="fila in tablaDinamica" :key="'fila-' + fila.key">
                            <td class="sticky-col font-weight-bold">
                                {{ fila.nombre }}
                            </td>
                            <td v-for="col in columnas" :key="'cell-' + fila.key + '-' + col.key">
                                {{ fila.valores[col.key] || 0 }}
                            </td>
                            <td class="total-cell">
                                {{ fila.total }}
                            </td>
                        </tr>
                        <tr class="total-row">
                            <td class="sticky-col">TOTAL</td>
                            <td v-for="col in columnas" :key="'total-' + col.key">
                                {{ totalPorColumna[col.key] || 0 }}
                            </td>
                            <td>{{ totalGeneral }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </v-card>

    </v-container>
</template>

<script>
import axios from 'axios';
import { utils, writeFileXLSX } from 'xlsx';

import {
    setDatos,
    getPaises,
    getDeptos,
    getCiudades,
    getPaisN,
    getDeptoN,
    getCiudadN,
    getOptionsByCodigo,
    getNameById,
    loadAll
} from '@/utils/catalogo';

import { setEstados } from '@/utils/validators';

export default {
    data() {
        return {
            datos: [],
            search: '',
            soloActivos: null,
            campoFila: 'oid_ciudad',
            campoColumna: 'oid_grado',
            Lgrado: [], Lcargo: [], Lunidad: [], Ldestino: [], Lcas: [], Lfrontera: [], Lfunciones: [], Lgpolicial: [], Lestado: [],
            LPais: [], LDepto: [], LCiudad: [],
            Catalogo: {
                Genero: [],
                EstadoCivil: [],
                Nacionalidad: [],
                TipoDocumento: [],
                TipoSangre: [],
                Parentesco: [],
            },
            opcionesActivos: [
                { text: 'Activos', value: 1 },
                { text: 'Inactivos', value: 0 }
            ],
            camposDisponibles: [
                { text: 'Ciudad', value: 'oid_ciudad' },
                { text: 'Departamento', value: 'oid_depto' },
                { text: 'País', value: 'oid_pais' },
                { text: 'Grado', value: 'oid_grado' },
                { text: 'Cargo', value: 'oid_cargo' },
                { text: 'Unidad', value: 'oid_unidad' },
                { text: 'Destino', value: 'oid_destino' },
                { text: 'Estado laboral', value: 'oid_estado' },
                { text: 'Género', value: 'oid_genero' },
                { text: 'Estado civil', value: 'oid_estado_civil' },
                { text: 'Categoría CAS', value: 'oid_categoria' },
                { text: 'Frontera', value: 'oid_frontera' },
                { text: 'Función policial', value: 'oid_funciones' },
                { text: 'Grado policial', value: 'grado_policial' },
                { text: 'Tipo documento', value: 'oid_tipo_documento' },
                { text: 'Tipo sangre', value: 'oid_tipo_sangre' }
            ],
            verFiltros: false,
            filtros: {
                oid_estado: [],
                oid_grado: [],
                oid_unidad: [],
                oid_destino: [],
                oid_categoria: [],
                oid_depto: [],
                oid_ciudad: [],
                oid_genero: [],
                oid_estado_civil: [],
                oid_cargo: [],
                oid_frontera: [],
                oid_funciones: [],
                grado_policial: [],
            },
        };
    },
    computed: {
        tituloFila() {
            const item = this.camposDisponibles.find(x => x.value === this.campoFila);
            return item ? item.text.toUpperCase() : 'FILA';
        },
        datosFiltrados() {
            let data = this.datos || [];

            const search = (this.search || '').toLowerCase().trim();

            if (search) {
                data = data.filter(x => {
                    const texto = `
                        ${x.nombres || ''}
                        ${x.primero_apellido || ''}
                        ${x.segundo_apellido || ''}
                        ${x.documento || ''}
                        ${x.correo || ''}
                        ${x.telefono || ''}
                    `.toLowerCase();

                    return texto.includes(search);
                });
            }

            if (this.soloActivos !== null && this.soloActivos !== undefined) {
                data = data.filter(x => {
                    const activo = x.activo === true || x.activo === 1 ? 1 : 0;
                    return activo === Number(this.soloActivos);
                });
            }

            data = this.aplicarFiltroMultiple(data, 'oid_estado', this.filtros.oid_estado);
            data = this.aplicarFiltroMultiple(data, 'oid_grado', this.filtros.oid_grado);
            data = this.aplicarFiltroMultiple(data, 'oid_unidad', this.filtros.oid_unidad);
            data = this.aplicarFiltroMultiple(data, 'oid_destino', this.filtros.oid_destino);
            data = this.aplicarFiltroMultiple(data, 'oid_categoria', this.filtros.oid_categoria);

            data = this.aplicarFiltroMultiple(data, 'oid_depto', this.filtros.oid_depto);
            data = this.aplicarFiltroMultiple(data, 'oid_ciudad', this.filtros.oid_ciudad);
            data = this.aplicarFiltroMultiple(data, 'oid_genero', this.filtros.oid_genero);
            data = this.aplicarFiltroMultiple(data, 'oid_estado_civil', this.filtros.oid_estado_civil);
            data = this.aplicarFiltroMultiple(data, 'oid_cargo', this.filtros.oid_cargo);
            data = this.aplicarFiltroMultiple(data, 'oid_frontera', this.filtros.oid_frontera);
            data = this.aplicarFiltroMultiple(data, 'oid_funciones', this.filtros.oid_funciones);
            data = this.aplicarFiltroMultiple(data, 'grado_policial', this.filtros.grado_policial);

            return data;
        },
        columnas() {
            const map = {};

            this.datosFiltrados.forEach(item => {
                const key = this.obtenerValorCampo(item, this.campoColumna);
                const nombre = this.obtenerNombreCampo(this.campoColumna, key);

                if (!map[key]) {
                    map[key] = {
                        key,
                        nombre
                    };
                }
            });

            return Object.values(map).sort((a, b) =>
                String(a.nombre).localeCompare(String(b.nombre))
            );
        },
        tablaDinamica() {
            const map = {};

            this.datosFiltrados.forEach(item => {
                const filaKey = this.obtenerValorCampo(item, this.campoFila);
                const columnaKey = this.obtenerValorCampo(item, this.campoColumna);

                const filaNombre = this.obtenerNombreCampo(this.campoFila, filaKey);

                if (!map[filaKey]) {
                    map[filaKey] = {
                        key: filaKey,
                        nombre: filaNombre,
                        valores: {},
                        total: 0
                    };
                }

                map[filaKey].valores[columnaKey] =
                    (map[filaKey].valores[columnaKey] || 0) + 1;

                map[filaKey].total++;
            });

            return Object.values(map).sort((a, b) =>
                String(a.nombre).localeCompare(String(b.nombre))
            );
        },
        totalPorColumna() {
            const total = {};

            this.datosFiltrados.forEach(item => {
                const columnaKey = this.obtenerValorCampo(item, this.campoColumna);
                total[columnaKey] = (total[columnaKey] || 0) + 1;
            });

            return total;
        },
        totalGeneral() {
            return this.datosFiltrados.length;
        }
    },
    async mounted() {
        await this.cargarCatalogos();
        await this.listar();
    },
    methods: {
        async cargarCatalogos() {
            await loadAll();
            await setDatos();

            this.LPais = getPaises();
            this.LDepto = getDeptos();
            this.LCiudad = getCiudades();

            this.Catalogo.Genero = getOptionsByCodigo('Genero');
            this.Catalogo.EstadoCivil = getOptionsByCodigo('EstadoCivil');
            this.Catalogo.Nacionalidad = getOptionsByCodigo('Nacionalidad');
            this.Catalogo.TipoDocumento = getOptionsByCodigo('TipoDocumento');
            this.Catalogo.TipoSangre = getOptionsByCodigo('TipoSangre');
            this.Catalogo.Parentesco = getOptionsByCodigo('Parentesco');

            const [g, c, u, d, cas, fb, fun, gp] = await Promise.all([
                axios.get('api/Grados/Listar'),
                axios.get('api/Cargos/Listar'),
                axios.get('api/Unidads/Listar'),
                axios.get('api/Destinos/Listar'),
                axios.get('api/Categoria_cas/Listar'),
                axios.get('api/FonteraBonos/Listar'),
                axios.get('api/Funciones/Listar'),
                axios.get('api/GradoPolicials/Listar')
            ]);

            this.Lgrado = g.data || [];
            this.Lcargo = c.data || [];
            this.Lunidad = u.data || [];
            this.Ldestino = d.data || [];
            this.Lcas = cas.data || [];
            this.Lfrontera = fb.data || [];
            this.Lfunciones = fun.data || [];
            this.Lgpolicial = gp.data || [];
            this.Lestado = await setEstados();
        },
        async listar() {
            try {
                const pageSize = 1000;
                let page = 1;
                let total = 0;
                let todos = [];

                do {
                    const response = await axios.get('api/PersonaInfoGenerals/ListarCompleto', {
                        params: {
                            page,
                            pageSize
                        }
                    });

                    const data = response.data.data || [];
                    total = response.data.total || 0;

                    todos = todos.concat(data);
                    page++;
                } while (todos.length < total);

                this.datos = todos;
            } catch (error) {
                console.error(error);
            }
        },
        obtenerValorCampo(item, campo) {
            const valor = item[campo];

            if (valor === null || valor === undefined || valor === '') {
                return 'SIN_DATO';
            }

            return String(valor);
        },
        obtenerNombreCampo(campo, valor) {
            if (valor === 'SIN_DATO') return 'Sin dato';

            const id = Number(valor);

            switch (campo) {
                case 'oid_ciudad':
                    return getCiudadN(id) || 'Sin ciudad';

                case 'oid_depto':
                    return getDeptoN(id) || 'Sin departamento';

                case 'oid_pais':
                    return getPaisN(id) || 'Sin país';

                case 'oid_grado':
                    return this.buscarNombre(this.Lgrado, id);

                case 'oid_cargo':
                    return this.buscarNombre(this.Lcargo, id);

                case 'oid_unidad':
                    return this.buscarNombre(this.Lunidad, id);

                case 'oid_destino':
                    return this.buscarNombre(this.Ldestino, id);

                case 'oid_estado':
                    return this.buscarNombreEstado(id);

                case 'oid_categoria':
                    return this.buscarNombre(this.Lcas, id);

                case 'oid_frontera':
                    return this.buscarNombre(this.Lfrontera, id);

                case 'oid_funciones':
                    return this.buscarNombre(this.Lfunciones, id);

                case 'grado_policial':
                    return this.buscarNombre(this.Lgpolicial, id);

                case 'oid_genero':
                case 'oid_estado_civil':
                case 'oid_tipo_documento':
                case 'oid_tipo_sangre':
                    return getNameById(id) || 'Sin dato';

                default:
                    return valor || 'Sin dato';
            }
        },
        buscarNombre(lista, id) {
            const item = (lista || []).find(x => Number(x.oid) === Number(id));
            return item ? item.nombre : 'Sin dato';
        },
        buscarNombreEstado(id) {
            const item = (this.Lestado || []).find(x => Number(x.oid) === Number(id));
            return item ? item.n_estado : 'Sin dato';
        },
        exportarExcel() {
            const filas = [];

            const encabezado = {};
            encabezado[this.tituloFila] = this.tituloFila;

            this.columnas.forEach(col => {
                encabezado[col.nombre] = col.nombre;
            });

            encabezado.TOTAL = 'TOTAL';
            filas.push(encabezado);

            this.tablaDinamica.forEach(fila => {
                const row = {};
                row[this.tituloFila] = fila.nombre;

                this.columnas.forEach(col => {
                    row[col.nombre] = fila.valores[col.key] || 0;
                });

                row.TOTAL = fila.total;
                filas.push(row);
            });

            const total = {};
            total[this.tituloFila] = 'TOTAL';

            this.columnas.forEach(col => {
                total[col.nombre] = this.totalPorColumna[col.key] || 0;
            });

            total.TOTAL = this.totalGeneral;
            filas.push(total);

            const ws = utils.json_to_sheet(filas, {
                skipHeader: true
            });

            ws['!cols'] = [
                { wch: 35 },
                ...this.columnas.map(() => ({ wch: 18 })),
                { wch: 12 }
            ];

            const wb = utils.book_new();
            utils.book_append_sheet(wb, ws, 'Reporte');

            writeFileXLSX(
                wb,
                `Reporte_Dinamico_${new Date().toISOString().substring(0, 10)}.xlsx`
            );
        },
        aplicarFiltroMultiple(data, campo, valores) {
            if (!valores || valores.length === 0) return data;

            return data.filter(x =>
                valores.map(Number).includes(Number(x[campo]))
            );
        },
        limpiarFiltros() {
            this.search = '';
            this.soloActivos = null;

            this.filtros = {
                oid_estado: [],
                oid_grado: [],
                oid_unidad: [],
                oid_destino: [],
                oid_categoria: [],
                oid_depto: [],
                oid_ciudad: [],
                oid_genero: [],
                oid_estado_civil: [],
                oid_cargo: [],
                oid_frontera: [],
                oid_funciones: [],
                grado_policial: [],
            };
        },
    }
};
</script>

<style scoped>
.rep-root {
    background: #f7f8f3;
    min-height: calc(100vh - 80px);
    padding: 20px;
}

h2 {
    color: #5e672c;
    font-size: 30px;
    font-weight: 800;
    margin-bottom: 16px;
}

.filtros-card {
    border-radius: 14px !important;
    background: #ffffff !important;
}

.tabla-card {
    border-radius: 14px !important;
    overflow: hidden;
}

.tabla-wrap {
    overflow: auto;
    max-height: 75vh;
}

.rep-table {
    width: 100%;
    border-collapse: collapse;
    background: white;
    font-size: 13px;
}

.rep-table th {
    background: #8fd0df;
    color: #000;
    font-weight: 800;
    text-align: center;
    border: 1px solid #333;
    padding: 8px;
    white-space: nowrap;
}

.rep-table td {
    border: 1px solid #333;
    padding: 6px 8px;
    text-align: center;
    white-space: nowrap;
}

.rep-table td:first-child {
    text-align: left;
}

.sticky-col {
    position: sticky;
    left: 0;
    z-index: 2;
    background: #ffffff;
}

thead .sticky-col {
    background: #8fd0df;
    z-index: 4;
}

.total-cell {
    font-weight: 800;
}

.total-row {
    font-weight: 800;
    background: #f5f5f5;
}

.total-row .sticky-col {
    background: #f5f5f5;
}
</style>